export const TABS_ITEMS = [
    { label: "Уже были у нас?", value: true },
    { label: "Впервые здесь?", value: false },
]
